<script>
    import I18n from '@js/modules/translations';

    const {
        // Active mode label (empty = hidden), a short contextual hint, and the one-click exit.
        label = '',
        hint = '',
        onExit
    } = $props();
</script>

{#if label}
    <div class="map-mode-banner"
         role="status"
         aria-live="polite">
        <span class="map-mode-banner-dot"
              aria-hidden="true"></span>

        <span class="map-mode-banner-text">
            <span class="map-mode-banner-label">{label}</span>
            {#if hint}
                <span class="map-mode-banner-hint">{hint}</span>
            {/if}
        </span>

        <button type="button"
                class="map-mode-banner-exit"
                onclick={onExit}>
            {I18n.t('js.maps.mode_banner.exit')}
            <svg class="map-mode-banner-exit-icon"
                 xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 14 14"
                 fill="none"
                 aria-hidden="true">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
        </button>
    </div>
{/if}
